import { IpillsByReference } from '../types/orders';
import { EXCLUDE_PILL, IFormatPills } from '../types/pills';

export const formatPills = ({ pillsList, excludeItems }: IFormatPills) => {
  const pills = typeof pillsList === 'string' ? JSON.parse(pillsList) : pillsList;
  if (pills) {
    const myKeys = Object.keys(pills);
    const myPillsList = [];
    const tagProfilesList = [];
    if (myKeys.length > 0) {
      for (const key of myKeys) {
        const exludeKey = excludeItems?.includes(key);
        if (!key.includes('Perfil') && !key.includes('Gama') && !exludeKey) {
          const objetPill = { name: key, value: pills?.[key] };
          if (key === 'Cargo') {
            myPillsList.unshift(objetPill);
          } else {
            myPillsList.push(objetPill);
          }
        }
        if (key.includes('Perfil')) {
          const objetPill = { name: key, value: pills?.[key] };
          tagProfilesList.push(objetPill);
        }
      }
      const formattedPillList = { pills: myPillsList, profiles: tagProfilesList };
      return formattedPillList;
    }
    return undefined;
  }
  return undefined;
};

export const filterPillsToShow = (pills?: IpillsByReference): string[] => {
  if (!pills) return [];
  const filteredPills = Object.entries(pills).filter(
    ([key, _]) => !Object.values(EXCLUDE_PILL).includes(key as unknown as EXCLUDE_PILL)
  );
  const pillsToShow = filteredPills.map(([_, value]) => value);
  return pillsToShow;
};

export const filterPillsIncludingKeys = (pills?: IpillsByReference): IpillsByReference => {
  if (!pills) return {};
  const filteredPills = Object.entries(pills).filter(
    ([key, _]) => !Object.values(EXCLUDE_PILL).includes(key as unknown as EXCLUDE_PILL)
  );
  return Object.fromEntries(filteredPills);
};
